import React from 'react';
import { clsx } from 'clsx';
import CharacterAvatar from './CharacterAvatar';

const CharacterQuote = ({ characterId, quote, showAvatar = true, className }) => {
  const quoteStyles = {
    philemon: 'character-quote-philemon',
    xenia: 'character-quote-xenia',
    theron: 'character-quote-theron',
  };

  const name = characterId?.charAt(0).toUpperCase() + characterId?.slice(1);

  return (
    <div className={clsx('flex gap-3', className)}>
      {showAvatar && <CharacterAvatar characterId={characterId} size="sm" />}
      <div className="flex-1">
        <div className={clsx(quoteStyles[characterId] || 'character-quote')}>
          <p className="text-sm leading-relaxed">&ldquo;{quote}&rdquo;</p>
        </div>
        <p className="text-xs text-courtyard-stone/80 mt-1 font-medium">{name}</p>
      </div>
    </div>
  );
};

export default CharacterQuote;
